import React from 'react';
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils';
export const FanvoiceWrapper = ({ children }) => {
  const blockName = 'fanvoice';
  return (
     <section className={ `${blockName}__wrapper` }>
        { cloneChildrenWithProps(children, { blockName }) }
     </section>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceWrapper.js